<template>
  <div class="f-ast f-v">
    <donut-modal-sections-title
      title="Name your Donut channel"
      title-svg="nucleo/slack"
      :title-image-version="1"
    />
    <div class="t gray m-bx1">{{ description }}</div>
    <donut-input-new-channel
      v-model="channelName"
      :placeholder="$i18n.t('shoutouts.shoutout', { count: 2 }).toLowerCase()"
      @update-is-valid="(val) => channelNameIsValid = val"
    />
    <donut-modal-sections-actions
      button-text="Create Channel"
      :is-save-disabled="!channelNameIsValid"
      :save-function="onSubmit"
    />
  </div>
</template>

<script setup>
  import { ref, computed, inject } from 'vue';
  import { useStore } from 'vuex';

  const $i18n = inject('$i18n');
  const { state } = useStore();

  const description = computed(() => `Create a new Slack channel in which Donut will detect and reward public ${$i18n.t('shoutouts.shoutout', { count: 2 })}. Doing this will not trigger any messages to anyone besides you.`);

  // Channel Name Input
  const channelName = ref('');
  const channelNameIsValid = ref(false);

  // Submission
  const onSubmit = () => {
    state.modal.data.onSubmit(channelName.value);
  };
</script>
